export enum FeatureSelectionMode {
  Features = 'Features',
  Choices = 'Choices',
}
